import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import {
  Container,
  CssBaseline,
  Grid,
  Typography,
  Button,
  TextField,
  CardMedia,
  Alert,
} from "../../components/shared/MaterialUI";

import { Link } from "react-router-dom";

import { useUI } from "../../app/context/ui";

import AuthService from "../../services/AuthService";

import logo from "../../assets/images/login-logo.png";
import { LoginStyles } from "../../assets/css/login-style";

const ForgotPassword = () => {

  const [hasError, setHasError] = useState({});
  const [requestFailed, setRequestFailed] = useState(false);
  const loginStyle = LoginStyles();
  const { blockUI } = useUI();
  const authService = new AuthService();
  const [requestRecoverPassword, setrequestRecoverPassword] = useState(false);
  const divGoBackLogin = useRef();

  useEffect(() => {
    if (!setRequestFailed) {
      setHasError("");
    }
  }, [requestFailed]);

  useEffect(() => {
    if (requestRecoverPassword){
      divGoBackLogin.current.style.marginTop = "-67px";
      divGoBackLogin.current.style.marginBottom = "67px";
    }
  }, [requestRecoverPassword])

  const LoginSchema = Yup.object().shape({
    email: Yup.string().email("Invalid email").required("Email is required")
  });

  const onSubmit = async (values) => {
    try {
      blockUI.current.open(true);
      setRequestFailed(false);
      const r1 = await authService.passwordReset(values);
      blockUI.current.open(false);
      (r1.status === 200) && setrequestRecoverPassword(r1.data.message);

    } catch (e) {
      blockUI.current.open(false);
      setRequestFailed(true);
      setHasError({ message: e.response.data.message });
    }
  };

  return (
    <Container component="main" maxWidth="lg" className={loginStyle.bgMain}>
      <Typography component="div" className={loginStyle.panForm}>
        <CssBaseline />
        <Typography component="div" className={loginStyle.alignItemsAndJustifyContent}>
          <CardMedia
            className={loginStyle.cardLogo}
            component="img"
            image={logo}
            title="Mow Manager"
          />
        </Typography>

        {requestRecoverPassword && (
          <Alert severity="success" color="info" style={{ align: 'center' }}>
            We've sent an email to reset your password
          </Alert>
        )}

        <Typography component="div">
          {requestFailed && (
            <p className={loginStyle.formError} align="center">{hasError.message}</p>
          )}
        </Typography>

        <Formik
          initialValues={{
            email: "",
          }}
          onSubmit={(values, { resetForm }) => {
            onSubmit(values, resetForm);
          }}
          validationSchema={LoginSchema}
        >
          {(props) => {
            const {
              values,
              touched,
              errors,
              handleBlur,
              handleChange,
            } = props;
            return (
              <Form className={loginStyle.formMain} style={{ top: '90px' }}>
                {
                  (!requestRecoverPassword)
                    && (
                      <>

                        <TextField
                          margin="normal"
                          className={classNames(loginStyle.inputEmail)}
                          required
                          fullWidth
                          name="email"
                          id="email"
                          autoComplete="email"
                          autoFocus
                          value={values.email}
                          type="email"
                          helperText={
                            errors.email && touched.email ? errors.email : ""
                          }
                          error={!!(errors.email && touched.email)}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          placeholder="Email"
                        />

                        <Button
                          type="submit"
                          fullWidth
                          variant="contained"
                          color="primary"
                          className={classNames(loginStyle.btnSubmit, loginStyle.btnSendReset)}
                        >
                        Send Reset Link
                        </Button>

                      </>
                    )
                }

                <Grid container justify="flex-end" ref={divGoBackLogin} className={loginStyle.gridForgotPassword}>
                  <Grid item>
                    <Link to="/login" variant="body2" className={loginStyle.link}>
                      Go back to login
                    </Link>
                  </Grid>
                </Grid>

              </Form>
            );
          }}
        </Formik>
      </Typography>
    </Container>
  );
};

export default ForgotPassword;
